import {
    baseUrl
} from '@/config/env';
import request from '@/router/axios';
import {
    parseParam
} from '@/util/util';

export const findGoods = (params) => {
    params = parseParam(params)
    params = params + "&type=WATERPROOF";
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/pure_water_goods?` + params,
        method: 'GET'
    })
}
export const addGoods = (params) => {
    params.type = "WATERPROOF";
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/pure_water_goods`,
        method: 'POST',
        data: params
    })
}
export const getGoodsForm = (id) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/pure_water_goods/${id}`,
        method: 'GET'
    })
}
export const updateGoods = (params) => {
    params.type = "WATERPROOF";
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/pure_water_goods`,
        method: 'PUT',
        data: params
    })
}
export const findProject = (params) => {
    params = parseParam(params)
    params = params + "&type=WATERPROOF";
    return request({
        url: `${baseUrl}/joins-work/v2/project/select?` + params,
        method: 'GET'
    })
}
export const findAllSuperiorDepartment = () => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/department/findAllSuperiorDepartment`,
        method: 'GET'
    })
}
export const findProvince = () => {
    return request({
        url: `${baseUrl}/joins-basic/v1/province`,
        method: 'GET'
    })
}
export const findCitys = (id) => {
    return request({
        url: `${baseUrl}/joins-basic/v1/province/citys/${id}`,
        method: 'GET'
    })
}
export const findAreas = (id) => {
    return request({
        url: `${baseUrl}/joins-basic/v1/province/areas/${id}`,
        method: 'GET'
    })
}
/**
 * 控件类型列表
 */
export const findDataSourceFields = () => {
    return request({
        url: `${baseUrl}/joins-work/v1/dataSource/fields`,
        method: 'GET'
    })
}
/**
 * 数据源
 */
export const findDataSourceAll = () => {
    return request({
        url: `${baseUrl}/joins-work/v1/dataSource`,
        method: 'GET'
    })
}


export const delGoods = (deleteOption, ids) => {
    let temp = ids.join(",")
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/pure_water_goods/${temp}?option=${deleteOption}`,
        method: 'DELETE'
    })
}


